/** Cyan flash used by Notes / Projects save celebration overlay. */
export const SAVE_CELEBRATION_FLASH_COLOR = '#40E0D0';
export const SAVE_CELEBRATION_FLASH_MS = 1100;

const CELEBRATIONS_STORAGE_KEY = 'notes.celebrationsEnabled';

export const areSaveCelebrationsEnabled = (): boolean => {
    try {
        const raw = localStorage.getItem(CELEBRATIONS_STORAGE_KEY);
        if (raw === null) {
            return true;
        }
        return raw === '1' || raw === 'true';
    } catch {
        return true;
    }
};

export const runConfettiBurst = (): void => {
    try {
        const duration = 2100;
        const count = 40;
        const w = window.innerWidth;
        const h = window.innerHeight;
        const canvas = document.createElement('canvas');
        canvas.style.position = 'fixed';
        canvas.style.left = '0';
        canvas.style.top = '0';
        canvas.style.pointerEvents = 'none';
        canvas.width = w;
        canvas.height = h;
        canvas.style.zIndex = '1500';
        document.body.appendChild(canvas);

        const fadeDuration = 700;
        const fadeLead = 400;
        const fadeStart = Math.max(0, duration - fadeLead);
        const fadeTimeout = window.setTimeout(() => {
            try {
                canvas.style.transition = `opacity ${fadeDuration}ms ease`;
                canvas.style.opacity = '0';
            } catch {
                /* ignore */
            }
        }, fadeStart);

        window.setTimeout(() => {
            try {
                if (canvas.parentNode) {
                    canvas.parentNode.removeChild(canvas);
                }
            } catch {
                /* ignore */
            }
            window.clearTimeout(fadeTimeout);
        }, fadeStart + fadeDuration + 80);

        const ctx = canvas.getContext('2d');
        if (!ctx) {
            return;
        }

        type Particle = {
            x: number;
            y: number;
            vx: number;
            vy: number;
            w: number;
            h: number;
            angle: number;
            va: number;
            color: string;
            ttl: number;
        };

        const colors = ['#FF6B6B', '#FFD93D', '#6BCB77', '#4D96FF', '#A86BFF', '#40E0D0'];
        const particles: Particle[] = [];
        for (let i = 0; i < count; i += 1) {
            const s = 6 + Math.random() * 10;
            particles.push({
                x: Math.random() * w,
                y: -20 - Math.random() * h * 0.1,
                vx: (Math.random() - 0.5) * 6,
                vy: 2 + Math.random() * 6,
                w: s,
                h: s,
                angle: Math.random() * Math.PI * 2,
                va: (Math.random() - 0.5) * 0.2,
                color: colors[Math.floor(Math.random() * colors.length)] ?? '#40E0D0',
                ttl: duration,
            });
        }

        canvas.style.opacity = '1';
        const start = performance.now();
        const frame = (time: number) => {
            const t = time - start;
            ctx.clearRect(0, 0, w, h);
            particles.forEach((p) => {
                p.x += p.vx;
                p.y += p.vy;
                p.vy += 0.06;
                p.angle += p.va;
                p.ttl -= 16;
                ctx.save();
                ctx.translate(p.x, p.y);
                ctx.rotate(p.angle);
                ctx.fillStyle = p.color;
                ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
                ctx.restore();
            });
            if (t < duration) {
                requestAnimationFrame(frame);
            } else {
                try {
                    if (canvas.parentNode) {
                        canvas.parentNode.removeChild(canvas);
                    }
                } catch {
                    /* ignore */
                }
            }
        };
        requestAnimationFrame(frame);
    } catch (err) {
        console.error('confetti error', err);
    }
};

export const playSaveSound = (): void => {
    try {
        const AudioCtx = window.AudioContext || (window as Window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
        if (!AudioCtx) {
            return;
        }
        const ctx = new AudioCtx();
        const oscillator = ctx.createOscillator();
        const gain = ctx.createGain();
        oscillator.type = 'sine';
        oscillator.frequency.value = 880;
        gain.gain.value = 0;
        oscillator.connect(gain);
        gain.connect(ctx.destination);
        const now = ctx.currentTime;
        gain.gain.cancelScheduledValues(now);
        gain.gain.setValueAtTime(0, now);
        gain.gain.linearRampToValueAtTime(0.08, now + 0.01);
        gain.gain.exponentialRampToValueAtTime(0.001, now + 0.5);
        oscillator.start(now);
        oscillator.stop(now + 0.55);
        window.setTimeout(() => {
            try {
                void ctx.close();
            } catch {
                /* ignore */
            }
        }, 800);
    } catch (err) {
        console.error('playSaveSound err', err);
    }
};
